import { Component, Prop } from 'vue-property-decorator';
import { getPhoneNumberCountriesBySu } from '@/config/app.config';
import Vue from 'vue';

@Component
export default class InputTel extends Vue {
  @Prop({ required: true }) public name?: string;
  @Prop() public label?: string;
  @Prop({ default: false }) public required?: boolean;
  @Prop({ default: false }) public disabled?: boolean;
  @Prop({ default: false }) public readonly?: boolean;
  @Prop() public placeholder?: string;
  @Prop() public value?: string;
  @Prop({default: 'CH'}) public defaultCountry?: string;
  @Prop({default: true}) public dynamicPlaceholder?: boolean;
  @Prop({default: 'national'}) public mode?: string;
  public onlyCountries: string[] = [];
  protected randomId: string = Math.floor(Math.random() * Math.floor(100000000)).toString();

  protected mounted() {
    this.onlyCountries = getPhoneNumberCountriesBySu(this.$route.params.screening);
  }
}
